import api from './client';

const notasApi = {
  listar: (clienteId, desde, hasta) => {
    const params = {};
    if (desde) params.desde = desde.toISOString();
    if (hasta) params.hasta = hasta.toISOString();
    return api.get(`/clientes/${clienteId}/notas-soporte`, { params }).then((r) => r.data);
  },
  listarTodas: (desde, hasta) => {
    const params = {};
    if (desde) params.desde = desde.toISOString();
    if (hasta) params.hasta = hasta.toISOString();
    return api.get(`/notas-soporte`, { params }).then((r) => r.data);
  },
  obtener: (clienteId, notaId) =>
    api.get(`/clientes/${clienteId}/notas-soporte/${notaId}`).then((r) => r.data),
  crear: (clienteId, body) =>
    api.post(`/clientes/${clienteId}/notas-soporte`, body).then((r) => r.data),
  actualizar: (clienteId, notaId, body) =>
    api.put(`/clientes/${clienteId}/notas-soporte/${notaId}`, body).then((r) => r.data),
  eliminar: (clienteId, notaId) =>
    api.delete(`/clientes/${clienteId}/notas-soporte/${notaId}`),
  previewRelacion: (clienteId, body) =>
    api.post(`/clientes/${clienteId}/relaciones-desde-notas/preview`, body).then((r) => r.data),
  crearRelacion: (clienteId, body) =>
    api.post(`/clientes/${clienteId}/relaciones-desde-notas/crear`, body).then((r) => r.data),
};

export default notasApi;
export { notasApi };

